import PropTypes from 'prop-types';

import { cn } from '#/lib/utils';

const STATUS_OPTIONS = [
  { value: '', label: '全部' },
  { value: 'ACTIVE', label: '啟用' },
  { value: 'INACTIVE', label: '停用' },
];

/** 工具列上的狀態切換（比表頭篩選更顯眼；帳號只支援 status 篩選）。 */
function AccessStatusToggle({ value = '', onChange }) {
  return (
    <div
      role="radiogroup"
      aria-label="狀態"
      className="inline-flex h-10 shrink-0 items-center rounded-md border border-gray-200 bg-[var(--surface-field)] p-1"
    >
      {STATUS_OPTIONS.map((option) => {
        const checked = value === option.value;

        return (
          <button
            key={option.value || 'all'}
            type="button"
            role="radio"
            aria-checked={checked}
            onClick={() => onChange(option.value)}
            className={cn(
              'h-full rounded px-3 text-sm transition-colors',
              checked
                ? 'bg-primary-500 text-white'
                : 'text-gray-700 hover:bg-primary-100',
            )}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}

AccessStatusToggle.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default AccessStatusToggle;
